import React from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import { OrganizationsTableComponent } from '../../../Tables';
import { IOrganization } from '../../../../modules/unsw-fhir/Organization';

const OrganizationTableCard = (props: {
  organizations: IOrganization[];
  loading?: boolean;
}) => (
  <Card>
    <CardBody>
      <CardTitle tag="h3">Organizations</CardTitle>
      <OrganizationsTableComponent
        organizations={props.organizations}
        loading={props.loading}></OrganizationsTableComponent>
    </CardBody>
  </Card>
);

export default OrganizationTableCard;
